import { atom } from 'recoil';

export const campaignsSearch = atom<string>({
    default: '',
    key: 'campaigns-search',
});
